import { IoSettingsOutline } from "react-icons/io5";

// // export const base_url = "http://209.38.124.59:5000";
export const base_url = "https://user.gassol.in:5000";
// export const base_url = "http://103.212.120.217:7935";
// // export const base_url = "https://user.gassol.in:7935";
// // export const base_url = "http://15.207.40.24:7935";

export const mailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneNumber =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/;

export const strongPwd = /(?=.*[a-z])(?=.*)(?=.*[0-9])(?=.*[^a-z0-9])(?=.{8,})/;

export const SUPER_ROLE = [
  { value: "2", label: "Admin" },
  { value: "4", label: "Sub-Branch" },
];

export const statusValue = [
  { label: "All Controllers", value: "0" },
  { label: "Active", value: "1" },
  { label: "Running", value: "2" },
  { label: "Deactivated", value: "3" },
];

export const SUPER_CONTROLLER_TABLE_HEAD = [
  "Hardware Id",
  "Branch",
  // "Location",
  "Company Name",
  "Running Status",
  "Activated On",
  <IoSettingsOutline className="text-3xl" />,
];

export const SUB_TABLE_HEAD = [
  "Hardware Name",
  "Running Status",
  // "Location",
  "Activated On",
  //   <IoSettingsOutline className="text-3xl" />,
];

export const HEAD_BRANCH_LIST_HEAD = [
  "Branch name",
  "Email",
  "Phone",
  "Created at",
];

export const HEAD_BRANCH_BURNER_RUN_TIME_HEAD = [
  "Burner",
  "Manifold",
  // "Manifold 2",
  "On date/time",
  "Off date/time",
  "Burner Running time",
  // "On Time Pressure",
  // "Off Time Pressure",
];

export const HOURLY_BURNER_RUN_TIME_REPORT_HEAD = [
  "Si. No.",
  "From",
  "To",
  "Burner 1",
  "Burner 2",
  "Burner 3",
  "Burner 4",
];

export const SUB_CONTROLLER_HOURLY_REPORT_HEAD = [
  "Time",
  "Manifold",
  "Burner Running time",
  "Power/Signal Strength",
];
export const CONTROLLER_MANIFOLD_REPORT_HEAD = [
  "Manifold",
  "No. of cylinders",
  "Date / On Time",
  "Date / Off Time",
  // "Total Duration",
  "On Pressure",
  "Total Lpg",
  "Total LPG Consumption",
  "Difference",
  // "Total net weight ",
  // " Difference",
  // "Total Residue",
  "Avg LPG Consumed",
  "total burner running time",
  "Burning",
];

export const LIST_HEAD_OFFICE_TABLE_HEAD = [
  "Name",
  "Phone",
  "Email",
  "Total Subbranches",
  "Password",
  <IoSettingsOutline className="text-3xl" />,
];

export const LIST_SUB_BRANCH_TABLE_HEAD = [
  "Name",
  "Head Branch Name",
  "Phone",
  "Email",
  "Password",
  <IoSettingsOutline className="text-3xl" />,
];

export const LIST_DELIVERY_BOY_TABLE_HEAD = [
  "Name",
  "Phone",
  "Email",
  "Password",
  "Assigned Branches",
  <IoSettingsOutline className="text-3xl" />,
];

export const LIST_MY_CONTROLLER_TABLE_HEAD = [
  "Hardware ID",
  "company name",
  "branch",
  "running status",
  "Activated on",
  <IoSettingsOutline className="text-3xl" />,
];

export const LIST_CYLINDER_WEIGHT_TABLE_HEAD = [
  "Date",
  "Gross weight",
  "Tare weight",
  "Net weight",
  "Returned Weight",
  "LPG consumed",
  "Residue",
  "Manifold",
];

export const LIST_POSTRUN_REPORT_TABLE_HEAD = [
  "Manifold",
  "Start Date/Time",
  "End Date/Time",
  "Mode/Cylinder",
  "Loaded On",
  // "Duration",
  // "Postrun Count",
  "Current Status",
];

export const LIST_OFFLINE_REPORT_TABLE_HEAD = [
  "End Date/Time",
  "Start Date/Time",
];

export const LIST_OFFTIME_REPORT_TABLE_HEAD = ["Off Date/Time", "On Date/Time"];

export const LIST_GLD_LOG_TABLE_HEAD = [
  "Zone",
  "sensor",
  "sensor status",
  "Start Date & Time",
  "End Date & Time",
];

export const LIST_BYPASS_TABLE_HEAD = [
  "Sl. No.",
  "Hardware ID",
  "Branch",
  "Phone number",
  "Bypass on",
  // "Resolved on",
  "Current Status",
];

export const LIST_HEAD_OFFLINE_TABLE_HEAD = [
  "Sl. No.",
  "Hardware ID",
  "Branch",
  "Phone Number",
  "Start Date & Time",
  "End Date & Time",
];

export const LIST_HEAD_EMPTYING_TABLE_HEAD = [
  "Sl. No.",
  "Hardware ID",
  "Branch",
  "Phone Number",
  "Manifold",
  "Start Date & Time",
  "End Date & Time",
  "Mode/Cylinder",
  "Loaded On",
  "Current Status",
];

export const LIST_NUMBER_OF_CYLINDER_PER_MANIFOLD = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31,
];

export const FILTER_GRAPH_INTERVAL = [
  { label: "2 mins", value: 2 },
  { label: "10 mins", value: 10 },
  { label: "15 mins", value: 15 },
  { label: "30 mins", value: 30 },
  { label: "1 hour", value: 60 },
  { label: "2 hour", value: 120 },
  { label: "5 hour", value: 300 },
  { label: "10 hour", value: 600 },
  { label: "12 hour", value: 720 },
  { label: "24 hour", value: 1439 },
];
